var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-divider',{attrs:{"position":"left"}},[_c('br'),_c('div',{staticClass:"vs-list--title"},[_vm._v("โครงการ "+_vm._s(_vm.customerName)+" บ้านเลขที่ "+_vm._s(_vm.getDisplayAddress))])])}
var staticRenderFns = []

export { render, staticRenderFns }